var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComfortIconcomponent = function SvgComfortIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.5c.787 0 1.537-.12 2.25-.345A7.494 7.494 0 0 1 8.25 9a7.494 7.494 0 0 1 5.25-7.155A7.503 7.503 0 0 0 3.75 9c0 4.14 3.36 7.5 7.5 7.5Z",
    fill: "#CECCC9"
  })));
};
export default SvgComfortIconcomponent;